module.exports = __webpack_public_path__ + "img/html-evolution-14.ed722fcf.webp";